import { Modal } from 'antd';
import { useState } from 'react';

import { sort_list } from '../Credit';
import { ReactComponent as FilterIcon } from './../../../../../assets/svg/filter.svg';
import { ReactComponent as SortIcon } from './../../../../../assets/svg/sort.svg';
import CreditFilterSidebar from './CreditFilterSidebar/CreditFilterSidebar';
import styles from './CreditFilterSort.module.css';
import CreditSortModal from './CreditSortModal/CreditSortModal';

const CreditFilterSort = (props) => {
  const { sort_visible, set_sort_visible, sort_value, set_sort_value } = props;

  const [sidebar_open, set_sidebar_open] = useState(false);

  return (
    <>
      <div className={styles.Container}>
        <div className={styles.FilterContainerFilterButton}>
          <button
            className={styles.FilterButton}
            onClick={() => set_sidebar_open(true)}
            type="button">
            <span>فیلتر</span>
            <FilterIcon className={styles.FilterIcon} />
          </button>
        </div>
        <div className={styles.FilterContainerSortButton}>
          <button
            className={styles.SortButton}
            onClick={() => set_sort_visible(!sort_visible)}
            type="button">
            <div>
              <span>
                مرتب سازی: {sort_list.find((sort_item) => sort_item.value === sort_value).label}
              </span>
            </div>
            <SortIcon className={styles.SortIcon} />
          </button>
          <Modal
            ClassName={styles.SortModal}
            closable={true}
            footer={false}
            onCancel={() => set_sort_visible(false)}
            visible={sort_visible}>
            <CreditSortModal
              set_sort_value={set_sort_value}
              set_sort_visible={set_sort_visible}
              sort_value={sort_value}
              sort_visible={sort_visible}
            />
          </Modal>
        </div>
      </div>
      <CreditFilterSidebar
        {...props}
        set_sidebar_open={set_sidebar_open}
        sidebar_open={sidebar_open}
      />
    </>
  );
};

export default CreditFilterSort;
